<template>
  <div class="quick-change-page">
    <el-card>
      <div slot="header"><span>Minor 快速变更</span></div>
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="120px">
        <el-form-item label="变更申请" prop="ecrId">
          <el-select v-model="form.ecrId" filterable style="width:100%" placeholder="选择已审 ECR" @change="onEcrChange">
            <el-option v-for="item in ecrs" :key="item.ecrId" :label="item.ecrCode + ' / ' + item.title" :value="item.ecrId" />
          </el-select>
        </el-form-item>
        <el-form-item label="物料" prop="materialId">
          <el-input v-model="form.materialCode" readonly>
            <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="BOM类型">
          <el-select v-model="form.bomType" style="width:160px">
            <el-option label="MBOM" value="mbom" />
            <el-option label="EBOM" value="ebom" />
          </el-select>
        </el-form-item>
        <el-form-item label="原版本" prop="versionBefore"><el-input v-model="form.versionBefore" placeholder="如 V1" style="width:160px" /></el-form-item>
        <el-form-item label="变更说明"><el-input v-model="form.changeSummary" type="textarea" :rows="2" /></el-form-item>
        <el-form-item v-if="form.bomType === 'mbom'" label="发布MBOM"><el-switch v-model="form.releaseMbom" /></el-form-item>
        <el-form-item label="BOM变更行">
          <el-button size="mini" type="primary" plain @click="addLine">新增行</el-button>
          <div class="quick-change-table-wrap">
          <el-table :data="changeLines" border size="small" class="quick-change-table" :header-cell-style="headStyle">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center" />
            <el-table-column label="动作" width="100">
              <template slot-scope="s">
                <el-select v-model="s.row.changeAction" size="mini">
                  <el-option label="修改" value="change" />
                  <el-option label="新增" value="add" />
                  <el-option label="删除" value="delete" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="子件物料" min-width="160">
              <template slot-scope="s">
                <el-input :value="s.row.childMaterialCode || s.row.childMaterialId" readonly size="mini">
                  <el-button slot="append" @click="openChildMaterialPicker(s.$index)">选</el-button>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="后用量" width="100">
              <template slot-scope="s"><el-input v-model="s.row.quantityAfter" size="mini" /></template>
            </el-table-column>
            <el-table-column label="操作" width="60" align="center">
              <template slot-scope="s"><el-button type="text" size="mini" @click="changeLines.splice(s.$index, 1)">删</el-button></template>
            </el-table-column>
          </el-table>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button v-if="isAuth('plm:plmQuickChange:apply')" type="primary" :loading="submitting" @click="submit">执行快速变更</el-button>
        </el-form-item>
      </el-form>
      <el-alert v-if="versionAfter" type="success" :closable="false" :title="`执行成功，新版本：${versionAfter}`" />
    </el-card>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
    <material-selector :visible.sync="childMaterialSelectorVisible" :multiple="false" @select="onChildMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector'

export default {
  name: 'PlmQuickChange',
  components: { MaterialSelector },
  data() {
    return {
      ecrs: [], form: { ecrId: '', materialId: '', materialCode: '', bomType: 'mbom', versionBefore: '', changeSummary: '', releaseMbom: true },
      changeLines: [], versionAfter: '', submitting: false, permCodes: [],
      materialSelectorVisible: false, childMaterialSelectorVisible: false, childPickIndex: -1,
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      formRules: {
        ecrId: [{ required: true, message: '请选择 ECR', trigger: 'change' }],
        materialId: [{ required: true, message: '请选择物料', trigger: 'change' }],
        versionBefore: [{ required: true, message: '原版本不能为空', trigger: 'blur' }]
      }
    }
  },
  created() { this.loadPerms(); this.loadEcrs() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadEcrs() {
      request.get('/plm/ecr/list').then(res => {
        this.ecrs = (res.data || []).filter(r => String(r.approveStatus) === '2' && String(r.changeLevel).toLowerCase() === 'minor')
      }).catch(() => { this.ecrs = [] })
    },
    onEcrChange(ecrId) {
      const row = this.ecrs.find(r => r.ecrId === ecrId)
      if (row && row.materialId) {
        this.form.materialId = row.materialId
        this.form.materialCode = row.materialCode || row.materialId
        this.$nextTick(() => { this.$refs.formRef && this.$refs.formRef.clearValidate('materialId') })
      }
    },
    addLine() {
      this.changeLines.push({ changeAction: 'change', childMaterialId: '', childMaterialCode: '', quantityAfter: 1, objectType: 'bom' })
    },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
    },
    openChildMaterialPicker(index) {
      this.childPickIndex = index
      this.childMaterialSelectorVisible = true
    },
    onChildMaterialSelect(row) {
      if (this.childPickIndex < 0 || !this.changeLines[this.childPickIndex]) return
      this.$set(this.changeLines[this.childPickIndex], 'childMaterialId', row.materialId)
      this.$set(this.changeLines[this.childPickIndex], 'childMaterialCode', row.materialCode)
    },
    submit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (!this.changeLines.length) {
          this.$message.warning('请添加 BOM 变更行')
          return
        }
        this.submitting = true
        request.post('/plm/change/apply', {
          ecrId: this.form.ecrId,
          materialId: this.form.materialId,
          bomType: this.form.bomType,
          versionBefore: this.form.versionBefore,
          changeSummary: this.form.changeSummary,
          releaseMbom: this.form.bomType === 'mbom' && this.form.releaseMbom,
          lines: this.changeLines.map(l => ({
            objectType: 'bom',
            changeAction: l.changeAction,
            childMaterialId: l.childMaterialId,
            quantityAfter: l.quantityAfter
          }))
        }).then(res => {
          this.versionAfter = res.data || ''
          this.$message.success('快速变更已执行')
        }).catch(() => {}).finally(() => { this.submitting = false })
      })
    }
  }
}
</script>

<style scoped>
.quick-change-page {
  min-width: 0;
}

.quick-change-table-wrap {
  max-width: 100%;
  overflow-x: auto;
  margin-top: 8px;
}

.quick-change-table {
  min-width: 470px;
}

@media (max-width: 600px) {
  .quick-change-page ::v-deep .el-form-item__label {
    float: none;
    display: block;
    width: auto !important;
    text-align: left;
    line-height: 28px;
  }

  .quick-change-page ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    min-width: 0;
  }

  .quick-change-page ::v-deep .el-form-item__content > .el-select,
  .quick-change-page ::v-deep .el-form-item__content > .el-input {
    width: 100% !important;
  }
}
</style>
